module.exports = __webpack_public_path__ + "img/computer_s.bbe4c6bd.png";